import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../../http/http.service';
import { CGeneralResponse, GeneralResponse } from '../../models/general-response/general-response';

@Injectable({
  providedIn: 'root'
})

export class NotificationService {
  public counterRequest: Subject<number> = new Subject();
  $counterRequest: Observable<number> = this.counterRequest.asObservable();
  private readonly _numDevoluciones = new BehaviorSubject<number>(0);
  readonly numDevoluciones$: Observable<number> = this._numDevoluciones.asObservable();
  public clickButtonNotification$: Subject<boolean> = new Subject<boolean>();

  constructor(private httpService: HttpService) {
  }

  sendNotify(message: number) {
    this.counterRequest.next(message);
  }

  clearNofify() {
    // RxJS 7 exige el valor explícito para Subject<number>; se usa 0 para alinear
    // con el mismo patrón de "limpiar contador" ya usado en sub-monetary-fee-request.component.ts:532.
    this.counterRequest.next(0);
  }

  getNotify(): Observable<any> {
    return this.$counterRequest;
  }

  public getCreditsRequestNotify(typeDocument: string, numberDocument: string, state: string, isRectifiableCase: boolean): Observable<GeneralResponse<any>> {
    if (!(typeDocument && numberDocument))
      return

    const params = {
      state: 'DEVOLUTION',
      isRectifiableCase: isRectifiableCase.toString()
    };

    return this.httpService.get(
      environment.CUOTA_MONETARIA.ACREDITACION_API_PREFIJO_URL + environment.CUOTA_MONETARIA.ACREDITACION_API_ENDPOINT_SOLICITUDES,
      `/${typeDocument}/${numberDocument}`,
      params)
      .pipe(
        switchMap((response: any) => {
          return of(response);
        }),
        catchError((error: any) => throwError(() => error))
      );
  }

  public getCreditsRequestNotifyBusiness(typeDocument: string, numberDocument: string, state: string, isRectifiableCase: boolean): Observable<GeneralResponse<any>> {
    if (!(typeDocument && numberDocument))
      return of(new CGeneralResponse('404', 'tipo y numero de identidad son necesarios', { body: [] }, false, 404));

    const params = {
      state: 'DEVOLUTION',
      isRectifiableCase: isRectifiableCase.toString()
    };

    return this.httpService.get(
      environment.CUOTA_MONETARIA.ACREDITACION_API_PREFIJO_URL,
      `${environment.CUOTA_MONETARIA.ACREDITACION_API_ENDPOINT_SOLICITUDES}/${typeDocument}/${numberDocument}/empresa`,
      params)
      .pipe(
        switchMap((response: any) => {
          this.clearNofify();
          if (response.body) {
            this.counterRequest.next(response.body.length);
          }
          return of(response);
        }),
        catchError((error: any) => throwError(() => error)) // then handle the error
      );
  }

  public getCreditsRequestActives(type_document: string, number_document: string, state: string[]): Observable<GeneralResponse<any>> {
    if (!(type_document && number_document))
      return

    let params = { states: state };
    return this.httpService.get(
      environment.CUOTA_MONETARIA.ACREDITACION_API_PREFIJO_URL,
      `${environment.CUOTA_MONETARIA.ACREDITACION_API_ENDPOINT_SOLICITUDES}/${type_document}/${number_document}/states`,
      params
    ).pipe(
      switchMap((response: any) => {
        this.clearNofify();
        if (response.body) {
          this.counterRequest.next(response.body.length);
        }
        return of(response);
      }),
      catchError((error: any) => throwError(() => error)) // then handle the error
    );
  }

  clickButtonNotification(viewNotifications: boolean) {
    this.clickButtonNotification$.next(viewNotifications);
  }

  setNumDevoluciones(count: number): void {
    this._numDevoluciones.next(count ?? 0);
  }

}

